module.exports = __webpack_public_path__ + "static/img/case_detail_06_2.ed9ed2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_detail_06_2.png
// module id = 7/cL
// module chunks = 34